import { merge } from '../../helper';

import exExternal from '../../external';
import * as exElement from '../../utils/element';
import * as exIcon from '../../utils/icon';

import type { IButtonConfig, TypeBuildReturn } from './types';

// ----------------------------------------------------------------------------

function create(config: IButtonConfig = {}): TypeBuildReturn {
    const defConfig: IButtonConfig = {
        type: 'button',
        bootstrap: {
            enabled: true,
        },
    };
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build = {
        elements: {},
    } as TypeBuildReturn;

    // ------------------------------------------------------------------------

    // Create element (button)
    const elButton = exElement.create({
        merge: defConfig,
        tag: 'button',
        attr: {
            type: defConfig.type,
        },
        class: {
            new: 'btn btn-secondary',
        },
    }) as HTMLButtonElement;
    build.elements.element = elButton;
    build.element = elButton;

    // ------------------------------------------------------------------------

    // Settings
    settings(build, defConfig);

    // ------------------------------------------------------------------------

    // If using bootstrap
    if (defConfig.bootstrap?.enabled === true) {
        // Bootstrap (button)
        const bsButton = new exExternal.bootstrap.Button(build.element);
        build.bs = bsButton;
    }

    // ------------------------------------------------------------------------

    //
    return build;
}

function settings(build: TypeBuildReturn, config: IButtonConfig = {}): void {
    const elements = build.elements;

    // If using collapse
    if (config.collapse === true) {
        elements.element.dataset.bsToggle = 'collapse';
    }

    // ------------------------------------------------------------------------

    // If using icon
    if (config.icon != null) {
        // Create element (icon)
        const elIcon = exIcon.create({
            merge: config.icon,
        });
        elements.icon = elIcon;
        elements.element.appendChild(elIcon);
    }
}

// ----------------------------------------------------------------------------

export { create };
